/**
 * 角色管理API配置
 * lixian
 */
const api = [{
  name: 'roleList',
  method: 'GET',
  desc: '角色列表',
  path: '/list',
  mock: false,
  params: {
    pageNum: 1,
    pageSize: 25
  }
},
{
  name: 'addRole',
  method: 'POST',
  desc: '添加角色',
  path: '/addRole',
  mock: false,
  params: {}
},
{
  name: 'checkRoleName',
  method: 'GET',
  desc: '检测名称是否重复',
  path: '/checkRoleName',
  mock: false,
  params: {}
},
{
  name: 'deleteRole',
  method: 'GET',
  desc: '删除角色',
  path: '/deleteRole',
  mock: false,
  append: true,
  params: {}
},
{
  name: 'getRole',
  method: 'GET',
  desc: '获取角色',
  path: '/getRole',
  mock: false,
  params: {}
},
{
  name: 'updateRole',
  method: 'POST',
  desc: '编辑角色',
  path: '/updateRole',
  mock: false,
  params: {}
},
{
  name: 'roleDetail',
  method: 'GET',
  desc: '编辑角色权限',
  path: '/roleDetail',
  append: true,
  mock: false,
  params: {}
},
{
  name: 'updateRoleFunction',
  method: 'POST',
  desc: '添加或删除角色权限',
  path: '/updateRoleFunction',
  mock: false,
  params: {}
},
{
  name: 'openRole',
  method: 'POST',
  desc: '开启角色',
  path: '/openRole',
  mock: false,
  params: {}
}]

export default {
  BASE_URL: '/sysRoleFunction',
  NAMESPACE: 'role',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/role.js